import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';




import {ApiMessageService} from '../../core/api-message.service';
import {TipoGerarchia} from './tipogerarchia.model';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';

@Injectable()
export class TipoGerarchiaService extends CommonService<TipoGerarchia> {

  public static ROUTE = 'tipogerarchia';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): TipoGerarchia {
    return JsonBaseBuilder.jsonToTipoGerarchia(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return TipoGerarchiaService.ROUTE;
  }

  public existingDescr(descr: string, id: number): Observable<boolean> {
    return this.getBoolean('/existingdescr', new HttpParams()
      .set('descr', descr)
      .set('id', id ? id + '' : ''));
  }

  public existingSigla(sigla: string, id: number): Observable<boolean> {
    return this.getBoolean('/existingsigla', new HttpParams()
      .set('sigla', sigla)
      .set('id', id ? id + '' : ''));
  }


  public getTable(items: TipoGerarchia[]): Table {
    return Table.buildBaseTable(TipoGerarchia.getTableKeys(), items);
  }

}
